import { convertToEnglishNumber } from "./convertToEnglishNumber";

export const createDecimalRegex = (decimals = 0, allowMinus = true) => {
  const decimalCount = Math.max(0, Number(decimals) || 0);

  const sign = allowMinus ? "-?" : "";

  if (decimalCount === 0) {
    return new RegExp(`^${sign}\\d+$`);
  }

  return new RegExp(`^${sign}\\d+(\\.\\d{0,${decimalCount}})?$`);
};

export const isValidNumericFormat = (
  value,
  decimals = 0,
  allowMinus = true,
) => {
  const regex = createDecimalRegex(decimals, allowMinus);

  return regex.test(value);
};



export const normalizeNumeric = (value) => {
  let str = convertToEnglishNumber(value ?? "").trim();

  if (!str) {
    return "";
  }

  // تمام spaceها
  str = str.replace(/\s/g, "");

  // برای اطمینان از separatorهای مختلف
  str = str
    .replace(/[٬،]/g, ",")
    .replace(/٫/g, ".");

  const commaIndex = str.lastIndexOf(",");
  const dotIndex = str.lastIndexOf(".");

  // مثال: 1,234,567.89
  // یا:    1.234.567,89
  if (commaIndex !== -1 && dotIndex !== -1) {
    if (commaIndex > dotIndex) {
      // 1.234.567,89 => 1234567.89
      str = str
        .replace(/\./g, "")
        .replace(/,/g, (match, offset) =>
          offset === commaIndex ? "." : ""
        );
    } else {
      // 1,234,567.89 => 1234567.89
      str = str.replace(/,/g, "");
    }
  }

  // فقط comma
  else if (commaIndex !== -1) {
    const parts = str.split(",");

    // یک comma و حداکثر 2 رقم بعد آن => اعشار
    // 123,45 => 123.45
    if (
      parts.length === 2 &&
      parts[1].length > 0 &&
      parts[1].length <= 2
    ) {
      str = `${parts[0]}.${parts[1]}`;
    } else {
      // 123,456
      // 123,456,789
      str = str.replace(/,/g, "");
    }
  }

  return str;
};

export const isNumeric = (value) => {
  if (value === "" || value === "-" || value === "-.") {
    return false;
  }

  return /^-?\d+(\.\d+)?$/.test(value);
};

export const toNumber = (value) => {
  if (!isNumeric(value)) {
    return NaN;
  }

  return Number(value);
};
